import { useEffect, useState } from 'react';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';

type DraggableStaticListProps = {
  className?: string;
  label: string;
  items: JSX.Element[];
  initialOpen?: boolean;
  /** Optional category description shown as a hover tooltip on the label. */
  description?: string;
  /** react-tooltip target id used to render the description tooltip. */
  tooltipId?: string;
  /**
   * Renders a "New" badge on the right of the row. Only top-level categories
   * pass this — subcategory rows use the same component and leave it off.
   */
  isNew?: boolean;
};

export default function DraggableStaticList({
  className,
  label,
  items,
  initialOpen = false,
  description,
  tooltipId,
  isNew = false,
}: DraggableStaticListProps) {
  const [open, setOpen] = useState(() => initialOpen);

  useEffect(() => setOpen(initialOpen), [initialOpen]);

  return (
    <div className={`w-full ${className ? className : ''}`}>
      <div
        onClick={() => setOpen((prevState) => !prevState)}
        className="flex flex-row items-center hover:bg-gray-200 cursor-pointer p-1 -ml-2 rounded-lg"
      >
        <div>{open ? <FaAngleUp /> : <FaAngleDown />}</div>
        <div
          className="pl-1"
          data-tooltip-id={description ? tooltipId : undefined}
          data-tooltip-content={description || undefined}
        >
          {label}
        </div>
        {isNew && (
          <span
            data-tour="category-new-badge"
            className="ml-auto mr-1 shrink-0 rounded-full bg-primary px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white"
          >
            New
          </span>
        )}
      </div>
      <div
        className={`pl-5 flex flex-row h-full w-full ${
          open ? 'visible' : 'hidden'
        }`}
      >
        <div>
          {items.map((item, idx) => (
            <div className="py-0.5" key={idx}>
              {item}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
